export const chatSettingsOption = {
	optionsData: [],
};
